import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Normalize country_code + mobile_num → international display, e.g. "+7 929 951-78-72".
 */
export function formatPhoneDisplay(
  countryCode?: string | null,
  mobileNum?: string | null,
): string {
  const cc = String(countryCode ?? "").trim();
  const num = String(mobileNum ?? "").trim();
  if (!cc && !num) return "";

  let e164: string;
  if (num.startsWith("+")) {
    e164 = num;
  } else {
    const dial = cc.replace(/[^\d+]/g, "");
    const local = num.replace(/\D/g, "");
    const dialDigits = dial.replace(/\D/g, "");
    const prefix = dial.startsWith("+")
      ? dial
      : dialDigits
        ? `+${dialDigits}`
        : "";
    // mobile_num already includes country digits, or is a full national number
    if (dialDigits && local.startsWith(dialDigits)) {
      e164 = `+${local}`;
    } else if (!prefix && local.length >= 10) {
      e164 = `+${local}`;
    } else {
      e164 = `${prefix}${local}`;
    }
  }

  const cleaned = e164.replace(/[^\d+]/g, "");
  const phone = parsePhoneNumberFromString(
    cleaned.startsWith("+") ? cleaned : `+${cleaned}`,
  );
  if (phone) return phone.formatInternational();

  // RU fallback: +7 XXX XXX-XX-XX
  const digits = cleaned.replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("7")) {
    return `+7 ${digits.slice(1, 4)} ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9)}`;
  }

  return [cc, num].filter(Boolean).join(" ").replace(/\s+/g, " ").trim();
}
